import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import { injectIntl, intlShape } from 'react-intl';
import { commonMessages } from '../../messages/commonMessages';

import closeIcon from '../../assets/images/close-icon.svg';

const TRANSITION_MS = 300;

const StyledModal = styled(ReactModal)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--c-shark);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 1200;

  .close-icon {
    display: block;
    width: calc(var(--fr) * 1.25);
    margin-bottom: calc(var(--fr) * 1.5);
    margin-left: auto;
  }

  .modalContentWrapper {
    min-height: 100%;
    overflow: auto;
    background-color: var(--c-shark);
    display: flex;
    max-width: 2100px;
    margin-left: auto;
    margin-right: auto;
  }

  .close {
    position: fixed;
    right: calc(var(--fr) * 1.3);
    top: calc(var(--fr) * 1.7);
    z-index: 1300;
  }

  &.animated {
    opacity: 0;
    transform: translateY(-16px);
    transition:
      opacity ${TRANSITION_MS}ms ease,
      transform ${TRANSITION_MS}ms ease;
  }

  &.animated.ReactModal__Content--after-open {
    opacity: 1;
    transform: none;
  }

  &.animated.ReactModal__Content--before-close {
    opacity: 0;
    transform: translateY(-16px);
  }
`;

const Modal = props => {
  const { onClose, isOpen, className, animated, children, intl } = props;

  return (
    <StyledModal
      onRequestClose={onClose}
      isOpen={isOpen}
      bodyOpenClassName={`modalOpen ${className}`}
      overlayClassName={animated ? 'overlay overlay--animated' : 'overlay'}
      className={animated ? 'animated' : undefined}
      closeTimeoutMS={animated ? TRANSITION_MS : 0}
    >
      <button onClick={onClose} className="close">
        <img
          className="close-icon"
          src={closeIcon}
          alt={intl.formatMessage(commonMessages.close)}
        />
      </button>
      <section className="modalContentWrapper">
        {children && <React.Fragment>{children}</React.Fragment>}
      </section>
    </StyledModal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  animated: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default injectIntl(Modal);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/common/Modal.js